import React from 'react';
import {Box} from "@mui/material";
import PollRangeTagBox from "../../components/PollRangeTagBox";
import {VoterOverview} from "../../components/appointment/VoterOverview";
import AlfyPollCalendar from "../../components/poll/AlfyPollCalendar";
import {CurrentVotedBox} from "../../components/poll/CurrentVotedBox";
import {AlfyButton} from "../../components/AlfyButton";
import {useFetchAppointmentWithPoll} from "../../states/appointment/server";
import {useParams} from "react-router-dom";
import {WARN_COLOR} from "../../constants/constants";

export interface AbsentPollStepPageProps {
    setStep: React.Dispatch<React.SetStateAction<number>>;
    selectedAbsentDates: Date[];
    selectedAttendDates: Date[];
    setSelectedAbsentDates: React.Dispatch<React.SetStateAction<Date[]>>;
    setSelectedAttendDates: React.Dispatch<React.SetStateAction<Date[]>>;
}

export const AbsentPollStepPage: React.FC<AbsentPollStepPageProps> = ({ setStep, selectedAbsentDates, selectedAttendDates, setSelectedAbsentDates, setSelectedAttendDates }) => {
    // hooks
    const { id: appointmentId } = useParams()
    const { data: appointment } = useFetchAppointmentWithPoll(appointmentId!)
    // const { data: memberMe } = useFetchMemberMe(appointmentId ?? '')

    /**
     * 이미 투표한 정보가 있다면 해당 정보를 불러온다.
     */
    // useEffect(() => {
    //     if (appointment && memberMe) {
    //         const memberPollItems = appointment.memberPollItems.filter(item => item.member.id === memberMe.id);
    //         const attendDates: Date[] = []
    //         const absentDates: Date[] = []
    //         memberPollItems.forEach(item => {
    //             if (item.attendType === AttendType.ABSENT) {
    //                 absentDates.push(item.pollItem.date);
    //             } else if (item.attendType === AttendType.ATTEND) {
    //                 attendDates.push(item.pollItem.date);
    //             }
    //         })
    //         setSelectedAbsentDates(absentDates);
    //         setSelectedAttendDates(attendDates);
    //     }
    // }, [appointment, memberMe]);

    if (!appointment) {
        return <></>;
    }

    return (
        <div className={"fullscreen"}>
            <Box height={"30px"}/>
            <div className="container">
                <span className={"primary-title-text"}>먼저 <span style={{color: WARN_COLOR}}>확실히 안되는 날</span>부터<br/>캘린더에서 전부 골라주세요</span>
                <Box height={"8px"}/>
                <PollRangeTagBox appointment={appointment!} />
            </div>
            <Box height={"20px"}/>
            <VoterOverview voters={appointment.getVotedMembers() ?? []} />
            <Box height={"20px"}/>
            <AlfyPollCalendar
                activeDates={appointment.getActiveDates()}
                datePollInfos={appointment?.toDatePollInfos() ?? []}
                selectedAbsentDates={selectedAbsentDates}
                selectedAttendDates={selectedAttendDates}
                setSelectedAbsentDates={setSelectedAbsentDates}
                setSelectedAttendDates={setSelectedAttendDates}
            />
            <Box height={"20px"}/>
            <CurrentVotedBox absentDates={selectedAbsentDates} attendDates={selectedAttendDates} />
            {!(selectedAbsentDates.length === 0 && selectedAttendDates.length === 0) && <Box height={"30px"} />}
            <AlfyButton text={"다 골랐어요"} onClick={() => {setStep(1)}} />
            <Box height={"20px"}/>
        </div>
    )
}